import { ClearStore } from '@/constants/actions';
import { SidepanelOpened } from '@/constants/getters';
import {
  SetSidepanelTriggered,
  ToggleTriggersPanel,
  ResetStore,
  SetConversationInputFocused,
  ToggleNewTriggerForm,
  SetShowSlidesPanel,
  SetOpenedConversation,
} from '@/constants/mutations';

const defaultState = () => {
  return {
    openedConversation: null,
    showPageTriggerPanel: false,
    showSlidesPanel: false,
    sidepanelTriggered: false,
    selectedSidePanelItem: null,
    showNewTriggerForm: false,
    conversationInputFocused: false,
  };
};

export const state = defaultState;

export const mutations = {
  [ResetStore]: (state) => {
    Object.assign(state, defaultState());
  },

  [SetConversationInputFocused](state, focused) {
    state.conversationInputFocused = focused;
  },

  [SetOpenedConversation](state, id) {
    state.openedConversation = id;
  },

  // toggles the triggers panel
  [ToggleTriggersPanel](state, data) {
    state.showPageTriggerPanel = data;
  },

  [SetShowSlidesPanel](state, data) {
    state.showSlidesPanel = data;
  },

  // toggles the whole sidepanel
  [SetSidepanelTriggered](state, data) {
    state.sidepanelTriggered = data;
  },

  [ToggleNewTriggerForm](state, value) {
    state.showNewTriggerForm = value;
  },
};

export const actions = {
  [ClearStore]({ commit }) {
    commit(ResetStore);
  },
};

export const getters = {
  [SidepanelOpened]: (state) => (
    state.sidepanelTriggered ||
    state.showPageTriggerPanel ||
    state.conversationInputFocused ||
    state.showSlidesPanel
  ),
};
